var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergyWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_10903)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_78_10903)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4.00378,
    fill: "#4DAE67"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_78_10903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3186 9.02049L16.1893 14.9539L20.2804 14.9676L14.7117 23.0112L15.841 16.4835L11.7501 16.4693L17.3186 9.02049ZM17.3194 8.01956C17.2924 8.01956 17.2654 8.02055 17.2388 8.02253C17.0622 8.03681 16.945 8.09587 16.8062 8.18921C16.728 8.24134 16.6575 8.30418 16.5967 8.37588C16.5785 8.3974 16.5613 8.41978 16.5452 8.44295L10.9366 15.8657C10.7151 16.1692 10.6826 16.5699 10.8528 16.9047C11.0227 17.2395 11.3663 17.4517 11.7429 17.4545L14.6321 17.4755L13.7237 22.8273C13.6374 23.2872 13.8826 23.7457 14.3143 23.9303C14.4397 23.9843 14.5749 24.012 14.7114 24.0119C15.026 24.0119 15.2845 23.8648 15.4784 23.599L21.094 15.5554C21.3154 15.2519 21.3477 14.8507 21.1778 14.5164C21.0079 14.1816 20.6643 13.9694 20.2877 13.9667L17.3985 13.9616L18.2971 9.25595C18.3161 9.17891 18.3257 9.09984 18.3256 9.02048C18.3256 8.47897 17.8944 8.03755 17.3549 8.02003C17.3429 8.01953 17.3311 8.01956 17.3194 8.01956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3186 9.02049L16.1893 14.9539L20.2804 14.9676L14.7117 23.0112L15.841 16.4835L11.7501 16.4693L17.3186 9.02049Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_78_10903",
    x: -16.0151,
    y: -12.0114,
    width: 64.0303,
    height: 64.0303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.00378
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.00757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101115 0 0 0 0 0.0619792 0 0 0 0 0.2125 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_78_10903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_78_10903",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_10903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_78_10903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0151,
    height: 16.0151,
    fill: "white",
    transform: "translate(8.00757 8.00781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyWithBg);
export default __webpack_public_path__ + "static/media/energy-with-bg.60806aa08188c98137f89c9896639f32.svg";
export { ForwardRef as ReactComponent };